module.exports = __webpack_public_path__ + "img/charity.e1475354.svg";